import { DropdownOption } from '@shared/interfaces/dev';
import { AddressType } from '@shared/types/addresses/address-type.type';

export const ADDRESS_TYPES: DropdownOption<AddressType>[] = [
  {
    label: 'Principale',
    value: 'main',
  },
  {
    label: 'Secondaire',
    value: 'secondary',
  },
  {
    label: 'Autre',
    value: 'other',
  },
] as const;
